import React from 'react';

function Home() {
  return (
    <div>
      <h1>Name: Matheus Costa Diniz.</h1>
      <br />
      <h2>
        Welcome to the Take Home Test for CDN Cloudflare Support Engineer
        opportunity.
      </h2>
      <br />
      <br />
      <p>
        Here you will find the answers to the questions asked on the Take Home
        Test for Cloudflare.
      </p>
      <br />
      <br />
      <p>
        <b>OBS:</b> To check the questions, please click on the links located on
        the NavBar above.
      </p>
    </div>
  );
}

export default Home;
